var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.234 21.7285C31.0817 22.248 31.0817 23.4785 30.234 23.998L20.609 29.6855C19.734 30.2051 18.6403 29.5762 18.6403 28.5371V17.1621C18.6403 16.041 19.8161 15.5762 20.609 16.041L30.234 21.7285Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.59009,
    y: 1.09961,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "white",
    strokeOpacity: 0.47,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrial);
export default __webpack_public_path__ + "static/media/Trial.3c283a4a35d4976a8b341875718c69a3.svg";
export { ForwardRef as ReactComponent };